.header {
    background: linear-gradient(90.75deg, #5e2391 0%, #8424d6 100.06%);
    align-items: center;
    background-size: 200% 200%;
    justify-content: space-between;
    padding: 8px 0 8px 16px;
}

.title {
    align-content: center;
}
.body {
    align-items: center;
    flex-direction: column;
    margin: 16px 16px 0 16px;
    background-size: 200% 200%;
}

.progressBackground {
    align-items: center;
    border-radius: 16px;
    height: 22px;
    background-image: url(./icons/PurpleDot.svg);
}

.indicator {
    margin-right: -3px;
    justify-content: center;
    align-items: center;
    position: absolute;
}
.endIndicator {
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 13px;
}
.progress {
    align-items: center;
    height: 22px;
    border-radius: 16px;
    background-color: var(--mantine-color-primary-3);
    justify-content: flex-end;
}
.indicatorText {
    justify-content: center;
    position: absolute;
}

.question {
    align-self: flex-start;
}

.top {
    flex-direction: column;
}
.content {
    flex: 0 1 content;
}

.answerText {
    align-content: center;
}

.correct {
    &[data-selected="true"] {
        border: 2px solid var(--mantine-color-success-5);
    }
}

.wrong {
    &[data-selected="true"] {
        border: 2px solid var(--mantine-color-error-5);
    }
}
.feedback {
    align-content: center;
    justify-content: center;
    border-top: 1px solid var(--mantine-color-dark-4);
    padding-bottom: 16px;
}

@keyframes fadeIn {
    from {
        height: 0px;
        opacity: 0;
    }
    to {
        height: 68px;
        opacity: 1;
    }
}
.feedbackDown {
    overflow-y: hidden;
    animation: fadeIn 0.25s ease-in-out;
}

.feedbackUp {
    overflow-y: hidden;
    animation: fadeOut 0.25s ease-in-out;
}

@keyframes fadeOut {
    from {
        height: 68px;
        opacity: 1;
    }
    to {
        height: 0px;
        opacity: 0;
    }
}
.button {
    &:hover {
        background:
            linear-gradient(0deg, #1a1d20, #1a1d20),
            linear-gradient(0deg, rgba(213, 215, 224, 0.08), rgba(213, 215, 224, 0.08));
    }
}
